import React, { useState, useEffect } from 'react';
import NumberFormat from 'react-number-format';
import { TextField } from '@fluentui/react';

const FieldNumberGrid = (props) => {

    const [value, setValue] = useState();

    const onChanged = (value) => {
        setValue(value.target.value);
        props.onChanged(props.keyfield, props.index, value.target.value, '', props.title);
    }

    useEffect(() => {
        setValue(props.value);
    }, [props.value]);

    return (
        <div style={{ marginLeft: 16 }}>
            <NumberFormat
                style={{ textAlign: 'end' }}
                customInput={TextField}
                onChange={onChanged}
                thousandSeparator={true}
                decimalScale={2}
                disabled={props.disable}
                value={value ? value : null}
                placeholder={props.placeholder}
            />
        </div>
    );
}

export default FieldNumberGrid;